/**
 * Shipments API (/api/v1/shipments)
 */

import { apiGet } from "./client";
import { ShipmentListParams, ShipmentListResponse } from "./types";

export function listShipments(
  params?: ShipmentListParams
): Promise<ShipmentListResponse> {
  return apiGet<ShipmentListResponse>("/shipments", params);
}
